// eslint-disable-next-line import/no-webpack-loader-syntax
require('expose-loader?LayoutApps!../../src/app/layout_apps');
